import { computed } from 'vue';
import ApiClient from '@/ApiClient';
import { useStateComposable } from '@/state/composables';

const { state } = useStateComposable({
  products: null,
});

let latestFetchId = 0;

const fetchProductsWithData = async divisionId => {
  const fetchId = ++latestFetchId;
  try {
    const products = await ApiClient.getProductsWithData(divisionId);
    if (fetchId === latestFetchId) {
      state.products = products;
    }
  } catch {
    if (fetchId === latestFetchId) {
      state.products = null;
    }
  }
};

// A tab is only hidden once the endpoint has explicitly reported no data for it.
// While the map is still loading (or the request failed) `products` is null, so
// we keep the tab visible rather than let a transient error wipe the navigation.
const hasData = key => computed(() => state.products?.[key] !== false);

export default function useProductsWithData() {
  return {
    fetchProductsWithData,
    hasPayData: hasData('pay'),
    hasLoansData: hasData('loans'),
    hasSavingsData: hasData('savings'),
    hasBudgetData: hasData('budget'),
    hasRewardsData: hasData('rewards'),
    hasFindCombineData: hasData('find_combine'),
    hasEducationData: hasData('education'),
  };
}
